import {
  InventoryItem,
  InventoryLog,
  CommonAsset,
  UserFeedback,
  MemberPetition,
  DefectWarrantyClaim,
  GovStatutoryFiling,
  ConciergeService,
  DownloadDocument,
} from '../types';

// 3. Initial Inventory Items
export const INITIAL_INVENTORY_ITEMS: InventoryItem[] = [
  {
    id: 'inv-1',
    code: 'EL-LED-18W',
    name: 'หลอดไฟ LED โคมเสาทางเดินถนน 18W',
    category: 'electrical',
    current_stock: 45,
    min_stock: 15,
    unit: 'หลอด',
    unit_price: 180,
    location: 'ตู้ช่าง A1-01',
    last_updated: '2026-08-14T09:30:00Z',
  },
  {
    id: 'inv-2',
    code: 'PL-CHLOR-90',
    name: 'คลอรีนก้อนสระว่ายน้ำ 90% (ถัง 5 กก.)',
    category: 'pool_chem',
    current_stock: 8,
    min_stock: 10,
    unit: 'ถัง',
    unit_price: 1250,
    location: 'ห้องปั๊มสระคลับเฮาส์',
    last_updated: '2026-08-12T14:15:00Z',
  },
  {
    id: 'inv-3',
    code: 'CL-BAG-36',
    name: 'ถุงขยะดำเหนียวพิเศษ 36x45 นิ้ว',
    category: 'cleaning',
    current_stock: 120,
    min_stock: 50,
    unit: 'แพ็ค',
    unit_price: 85,
    location: 'โกดังแม่บ้าน B-04',
    last_updated: '2026-08-15T08:00:00Z',
  },
  {
    id: 'inv-4',
    code: 'OF-A4-80G',
    name: 'กระดาษพิมพ์ Double A (A4 80 แกรม)',
    category: 'office',
    current_stock: 18,
    min_stock: 5,
    unit: 'รีม',
    unit_price: 145,
    location: 'สำนักงานนิติบุคคล',
    last_updated: '2026-08-10T11:00:00Z',
  },
  {
    id: 'inv-5',
    code: 'PB-VALVE-2IN',
    name: 'วาล์วน้ำทองเหลือง SANWA 2 นิ้ว (ท่อเมน)',
    category: 'plumbing',
    current_stock: 3,
    min_stock: 5,
    unit: 'ตัว',
    unit_price: 890,
    location: 'ตู้ช่าง A2-05',
    last_updated: '2026-08-08T16:20:00Z',
  },
  {
    id: 'inv-6',
    code: 'SEC-BAT-CONE',
    name: 'กระบองไฟกระพริบ รปภ. ชาร์จไฟได้',
    category: 'security_tools',
    current_stock: 12,
    min_stock: 4,
    unit: 'อัน',
    unit_price: 320,
    location: 'ป้อม รปภ. หลัก',
    last_updated: '2026-08-01T10:00:00Z',
  },
];

export const INITIAL_INVENTORY_LOGS: InventoryLog[] = [
  {
    id: 'log-1',
    item_id: 'inv-1',
    item_name: 'หลอดไฟ LED โคมเสาทางเดินถนน 18W',
    type: 'out',
    quantity: 4,
    requester_name: 'ช่างธีระเดช (งานอาคาร)',
    department: 'ฝ่ายช่างซ่อมบำรุง',
    purpose: 'เปลี่ยนโคมไฟทางเดินดับซอย 3 หน้าแปลง 88/24-26',
    created_at: '2026-08-14T17:30:00Z',
  },
  {
    id: 'log-2',
    item_id: 'inv-2',
    item_name: 'คลอรีนก้อนสระว่ายน้ำ 90%',
    type: 'out',
    quantity: 2,
    requester_name: 'ช่างประเสริฐ',
    department: 'ฝ่ายสระว่ายน้ำ & คลับเฮาส์',
    purpose: 'ปรับค่าสารเคมีสระว่ายน้ำคลับเฮาส์ประจำสัปดาห์',
    created_at: '2026-08-13T09:00:00Z',
  },
  {
    id: 'log-3',
    item_id: 'inv-3',
    item_name: 'ถุงขยะดำเหนียวพิเศษ 36x45 นิ้ว',
    type: 'out',
    quantity: 15,
    requester_name: 'หัวหน้าแม่บ้าน สมศรี',
    department: 'ฝ่ายรักษาความสะอาด',
    purpose: 'เติมถังขยะจุดรวมสวนส่วนกลาง 4 จุด',
    created_at: '2026-08-15T07:45:00Z',
  },
];

// 4. Initial Common Assets
export const INITIAL_COMMON_ASSETS: CommonAsset[] = [
  {
    id: 'ast-1',
    code: 'AST-CBH-01',
    name: 'อาคารสโมสรคลับเฮาส์หรู 2 ชั้น & ห้องรับรอง',
    category: 'clubhouse',
    location: 'โซนกลางโครงการ (ตรงข้ามซอย 4)',
    status: 'good',
    estimated_value: 12500000,
    installed_date: '2024-03-15',
    warranty_until: '2029-03-15',
    last_inspection: '2026-08-01',
    next_maintenance: '2026-11-01',
    responsible_staff: 'คุณศศิธร สุขสมบูรณ์ (ผู้จัดการนิติ)',
  },
  {
    id: 'ast-2',
    code: 'AST-POOL-SALT',
    name: 'สระว่ายน้ำระบบเกลือ Infinity Edge & ระบบกรองทราย',
    category: 'pool',
    location: 'ด้านหลังอาคารคลับเฮาส์',
    status: 'good',
    estimated_value: 3800000,
    installed_date: '2024-04-01',
    warranty_until: '2027-04-01',
    last_inspection: '2026-08-14',
    next_maintenance: '2026-08-21',
    responsible_staff: 'ช่างประเสริฐ สระว่ายน้ำ',
  },
  {
    id: 'ast-3',
    code: 'AST-FIT-EQP',
    name: 'เครื่องออกกำลังกายฟิตเนส Matrix (12 สถานี)',
    category: 'fitness',
    location: 'ชั้น 2 สโมสรคลับเฮาส์',
    status: 'good',
    estimated_value: 1450000,
    installed_date: '2024-05-10',
    warranty_until: '2027-05-10',
    last_inspection: '2026-08-10',
    next_maintenance: '2026-09-10',
    responsible_staff: 'เจ้าหน้าที่คลับเฮาส์',
  },
  {
    id: 'ast-4',
    code: 'AST-CCTV-4K',
    name: 'ระบบกล้อง CCTV 4K AI License Plate Recognition (32 จุด)',
    category: 'security_cctv',
    location: 'ทั่วโครงการ และซุ้มทางเข้า-ออก',
    status: 'good',
    estimated_value: 980000,
    installed_date: '2024-02-20',
    warranty_until: '2027-02-20',
    last_inspection: '2026-08-15',
    next_maintenance: '2026-09-15',
    responsible_staff: 'หัวหน้าชุด รปภ. สมศักดิ์',
  },
  {
    id: 'ast-5',
    code: 'AST-PUMP-MAIN',
    name: 'ปั๊มน้ำแรงดันสูง Grundfos Booster Pump 7.5 HP (2 ชุด)',
    category: 'water_pump',
    location: 'ห้องควบคุมระบบประปาส่วนกลาง',
    status: 'in_use',
    estimated_value: 520000,
    installed_date: '2024-03-01',
    warranty_until: '2026-09-01',
    last_inspection: '2026-08-12',
    next_maintenance: '2026-08-30',
    responsible_staff: 'ช่างธีระเดช งานระบบ',
  },
  {
    id: 'ast-6',
    code: 'AST-SOLAR-ST',
    name: 'โคมไฟถนนโซล่าร์เซลล์ Smart Sensor 120W (60 ชุด)',
    category: 'lighting',
    location: 'ถนนเมนหลักและซอยย่อย 1-8',
    status: 'good',
    estimated_value: 480000,
    installed_date: '2024-06-15',
    warranty_until: '2027-06-15',
    last_inspection: '2026-08-05',
    next_maintenance: '2026-12-05',
    responsible_staff: 'ฝ่ายช่างซ่อมบำรุง',
  },
];

// 5. Initial User Feedback & Complaints
export const INITIAL_USER_FEEDBACK: UserFeedback[] = [
  {
    id: 'fb-1',
    ticket_number: 'FB-2569-084',
    house_number: '88/35',
    resident_name: 'คุณวราภรณ์ มั่นคง',
    category: 'parking',
    title: 'มีรถภายนอกจอดขวางหน้าบ้านซอย 4 ช่วงเย็น',
    description: 'มีรถเก๋งสีบรอนซ์เงิน ทะเบียน 4กข-8921 จอดเลยแนวรั้วล้ำเข้ามาหน้าประตูบ้าน ทำให้ถอยรถเข้าออกลำบาก อยากให้ รปภ. ช่วยตรวจสอบและติดใบเตือนครับ',
    status: 'investigating',
    priority: 'medium',
    created_at: '2026-08-15T15:20:00Z',
    admin_reply: 'นิติบุคคลได้รับเรื่องและประสานงานหัวหน้า รปภ. เข้าตรวจสอบ พร้อมติดสติ๊กเกอร์แจ้งเตือนการจอดกีดขวางแล้วครับ',
    replied_at: '2026-08-15T16:00:00Z',
    replied_by: 'คุณศศิธร (นิติบุคคล)',
  },
  {
    id: 'fb-2',
    ticket_number: 'FB-2569-081',
    house_number: '88/12',
    resident_name: 'คุณอนุกูล พรหมดี',
    category: 'suggestion',
    title: 'เสนอเพิ่มชั้นวางพัสดุขนาดใหญ่ที่ป้อม รปภ. หรือจุดรับพัสดุ',
    description: 'ช่วงแคมเปญช้อปปิ้งออนไลน์ มีกล่องพัสดุขนาดใหญ่จำนวนมาก อยากเสนอให้นิติฯ เพิ่มชั้นวางขนาดพิเศษแยกประเภทกล่องใหญ่ เพื่อความปลอดภัยและหยิบง่ายขึ้นครับ',
    status: 'resolved',
    priority: 'low',
    created_at: '2026-08-13T10:45:00Z',
    admin_reply: 'ขอบพระคุณสำหรับข้อเสนอแนะค่ะ ทางนิติฯ ได้จัดซื้อชั้นวาง Extra Large Rack เพิ่มเติม 2 ชุด และติดตั้งเรียบร้อยแล้วค่ะ',
    replied_at: '2026-08-14T11:00:00Z',
    replied_by: 'คุณศศิธร (นิติบุคคล)',
    resident_rating: 5,
  },
  {
    id: 'fb-3',
    ticket_number: 'FB-2569-079',
    house_number: '88/58',
    resident_name: 'คุณกิตติศักดิ์ พงศ์ไพโรจน์',
    category: 'cleanliness',
    title: 'กิ่งไม้ต้นจามจุรีริมรั้วซอย 6 ยื่นบังแสงไฟส่องทาง',
    description: 'ช่วงค่ำทางเดินซอย 6 ค่อนข้างมืดเพราะกิ่งไม้บังโคมไฟถนน รบกวนส่งเจ้าหน้าที่ตัดแต่งกิ่งไม้ให้โปร่งด้วยครับ',
    status: 'resolved',
    priority: 'medium',
    created_at: '2026-08-11T14:10:00Z',
    admin_reply: 'ฝ่ายดูแลสวนได้ดำเนินการตัดแต่งกิ่งไม้และเช็คความสว่างโคมไฟถนนเรียบร้อยแล้วเมื่อวันที่ 12 ส.ค. ค่ะ',
    replied_at: '2026-08-12T17:00:00Z',
    replied_by: 'ฝ่ายงานสวนนิติบุคคล',
    resident_rating: 5,
  },
  {
    id: 'fb-4',
    ticket_number: 'FB-2569-085',
    house_number: '88/09',
    resident_name: 'คุณธนาคาร เจริญสุข',
    category: 'noise_pet',
    title: 'สุนัขเห่าเสียงดังช่วงดึกในซอย 1',
    description: 'ช่วงเวลา 23:00 - 02:00 น. มีสุนัขเห่าต่อเนื่อง รบกวนช่วงเวลานอนหลับ อยากให้นิติตรวจสอบบ้านที่เลี้ยงสัตว์และช่วยขอความร่วมมือครับ',
    status: 'pending',
    priority: 'high',
    created_at: '2026-08-15T20:30:00Z',
  },
];

// 7. Initial Member Petitions
export const INITIAL_MEMBER_PETITIONS: MemberPetition[] = [
  {
    id: 'pt-1',
    petition_number: 'PT-2569-042',
    house_number: '88/44',
    resident_name: 'คุณสมเกียรติ สว่างวงศ์',
    type: 'renovation',
    title: 'ขออนุญาตต่อเติมหลังคาโรงจอดรถหน้าบ้านและปูกระเบื้อง SPC',
    details: 'ต่อเติมโครงหลังคาเหล็กกล่องสีดำดีไซน์กลมกลืนกับตัวบ้าน พร้อมระแนงบังตาอลูมิเนียม ไม่มีการต่อเติมชิดแนวรั้วเกินระยะร่นตามกฎหมาย',
    deposit_amount: 10000,
    status: 'approved',
    submitted_at: '2026-08-10T11:00:00Z',
    contractor_name: 'บริษัท ทูเก็ตเตอร์ เดคคอร์ จำกัด (ช่างวิชัย)',
    work_start_date: '2026-08-18',
    work_end_date: '2026-08-28',
    approved_by: 'คุณศศิธร สุขสมบูรณ์ (ผู้จัดการนิติ)',
    approved_at: '2026-08-12T14:30:00Z',
  },
  {
    id: 'pt-2',
    petition_number: 'PT-2569-045',
    house_number: '88/19',
    resident_name: 'คุณพนิดา รุ่งเรืองทรัพย์',
    type: 'pet',
    title: 'ลงทะเบียนเลี้ยงสุนัขพันธุ์เล็ก (Pomeranian 1 ตัว)',
    details: 'สุนัขเพศผู้ อายุ 2 ปี ฉีดวัคซีนป้องกันพิษสุนัขบ้าครบถ้วน ไม่ปล่อยวิ่งอิสระนอกรั้วบ้าน และใช้สายจูงเมื่อพาเดินออกกำลังกายตามระเบียบ',
    status: 'approved',
    submitted_at: '2026-08-14T09:15:00Z',
    approved_by: 'คุณศศิธร สุขสมบูรณ์',
    approved_at: '2026-08-14T15:00:00Z',
  },
  {
    id: 'pt-3',
    petition_number: 'PT-2569-047',
    house_number: '88/88',
    resident_name: 'คุณประธาน วงศ์เกษม',
    type: 'rfid_keycard',
    title: 'ขอสติ๊กเกอร์ผ่านเข้า-ออกและบัตร RFID เพิ่มเติม 1 ชุด',
    details: 'ออกรถยนต์ใหม่ ยี่ห้อ BYD Seal สีขาว ทะเบียน 3ขพ-9921 กทม. ยื่นเอกสารสำเนาเล่มทะเบียนรถเรียบร้อย',
    deposit_amount: 300,
    status: 'reviewing',
    submitted_at: '2026-08-15T13:40:00Z',
  },
  {
    id: 'pt-4',
    petition_number: 'PT-2569-048',
    house_number: '88/102',
    resident_name: 'คุณนพดล เจริญรัตนพงศ์',
    type: 'debt_free_cert',
    title: 'ขอหนังสือรับรองปลอดหนี้ค่าส่วนกลางเพื่อการไถ่ถอนจำนอง',
    details: 'ต้องการหนังสือรับรองปลอดหนี้ส่งมอบให้สำนักงานที่ดิน ชำระค่าส่วนกลางครบถ้วนถึงงวดปัจจุบันแล้ว',
    status: 'pending',
    submitted_at: '2026-08-15T18:00:00Z',
  },
];

// 10. Initial Developer Defect Warranty Claims
export const INITIAL_DEFECT_CLAIMS: DefectWarrantyClaim[] = [
  {
    id: 'def-1',
    claim_number: 'DEF-2569-019',
    house_number: '88/112',
    resident_name: 'คุณธนภัทร สุวรรณฉัตร',
    category: 'roof_leak',
    title: 'น้ำซึมฝ้าเพดานบริเวณรอยต่อหลังคาโรงรถช่วงฝนตกหนัก',
    description: 'พบคราบน้ำและหยดน้ำซึมบริเวณฝ้าชายคาโรงจอดรถ แจ้งผู้พัฒนาโครงการ นราวดี กรุ๊ป เข้าตรวจสอบแนวซีลรางน้ำ',
    developer_contractor: 'นราวดี กรุ๊ป (ทีมเซอร์วิสหลังการขาย)',
    warranty_status: 'under_warranty',
    status: 'fixing',
    created_at: '2026-08-12T10:00:00Z',
    scheduled_date: '2026-08-16',
    dev_engineer_name: 'วิศวกร ธนดล (นราวดี เซอร์วิส)',
    notes: 'ช่างเข้ายิงซิลิโคน Polyurethane และตรวจแนวตะเข็บหลังคาเรียบร้อย รอทดสอบน้ำ',
  },
  {
    id: 'def-2',
    claim_number: 'DEF-2569-021',
    house_number: '88/135',
    resident_name: 'คุณมิ่งขวัญ รัตนเสวี',
    category: 'paint_finishing',
    title: 'สีผนังภายนอกด้านทิศตะวันออกมีรอยแตกลายงาบางจุด',
    description: 'บ้านส่งมอบเมื่อ 6 เดือนก่อน พบรอยร้าวลายงาของสีภายนอก ขอเคลมทาสีเก็บรอยตามการรับประกัน 1 ปี',
    developer_contractor: 'นราวดี กรุ๊ป (ทีมผู้รับเหมาสถาปัตย์)',
    warranty_status: 'under_warranty',
    status: 'inspection_scheduled',
    created_at: '2026-08-14T14:30:00Z',
    scheduled_date: '2026-08-19',
    dev_engineer_name: 'วิศวกร อรรถพล',
  },
  {
    id: 'def-3',
    claim_number: 'DEF-2569-015',
    house_number: 'ส่วนกลาง',
    resident_name: 'นิติบุคคล (ทรัพย์ส่วนกลาง)',
    category: 'common_infra',
    title: 'ตรวจเช็คท่อระบายน้ำเมนหลักแนวถนนเมนก่อนส่งมอบ 100%',
    description: 'ลอกท่อระบายน้ำและตรวจสอบระดับความลาดเอียง (Slope) ไม่ให้มีน้ำขัง',
    developer_contractor: 'ฝ่ายโยธาโครงการ นราวดี อิลิแกนซ์',
    warranty_status: 'under_warranty',
    status: 'resident_signed_off',
    created_at: '2026-08-01T09:00:00Z',
    scheduled_date: '2026-08-05',
    dev_engineer_name: 'คุณชัยวัฒน์ (ผู้จัดการโครงการ)',
    notes: 'ส่งมอบงานลอกท่อ 8 ซอยเรียบร้อย กรรมการนิติตรวจรับมอบแล้ว',
  },
];

// 12. Initial Government Statutory Filings
export const INITIAL_GOV_FILINGS: GovStatutoryFiling[] = [
  {
    id: 'gov-1',
    agency: 'land_dept',
    agency_name: 'สำนักงานที่ดินจังหวัดพระนครศรีอยุธยา',
    title: 'จดทะเบียนจัดตั้งนิติบุคคลหมู่บ้านจัดสรรและข้อบังคับนิติบุคคล',
    filing_year: '2568 - 2569',
    status: 'approved',
    due_date: '2026-03-31',
    filing_date: '2025-10-15',
    reference_number: 'อย.0024/น.บ.042/2568',
    handled_by: 'ฝ่ายกฎหมายนิติบุคคล & บ.บริหารอสังหาฯ',
    notes: 'ได้รับหนังสือสำคัญการจดทะเบียนนิติบุคคลหมู่บ้านจัดสรรเรียบร้อยแล้ว',
  },
  {
    id: 'gov-2',
    agency: 'cpa_audit',
    agency_name: 'ผู้สอบบัญชีรับอนุญาต (CPA Thailand) & กรมพัฒนาธุรกิจการค้า',
    title: 'จัดทำและส่งมอบรายงานงบการเงินประจำปี 2568 ให้ผู้สอบบัญชีตรวจรับรอง',
    filing_year: '2569',
    status: 'approved',
    due_date: '2026-04-30',
    filing_date: '2026-04-18',
    reference_number: 'AUDIT-NRW-2568-001',
    handled_by: 'คุณศศิธร & สนง.บัญชี พีเค ออดิท',
    notes: 'ผู้สอบบัญชีลงนามรับรองงบการเงินเรียบร้อย นำเสนอต่อที่ประชุมใหญ่สามัญประจำปีแล้ว',
  },
  {
    id: 'gov-3',
    agency: 'social_security',
    agency_name: 'สำนักงานประกันสังคมจังหวัดพระนครศรีอยุธยา',
    title: 'ยื่นแบบ สปส.1-10 รายงานการนำส่งเงินสมทบพนักงานนิติบุคคล (ม.33) ประจำเดือน',
    filing_year: '2569 (สิงหาคม)',
    status: 'submitted',
    due_date: '2026-08-15',
    filing_date: '2026-08-10',
    reference_number: 'SSO-AY-256908-4102',
    handled_by: 'ฝ่ายธุรการการเงินนิติบุคคล',
    notes: 'นำส่งเงินสมทบผ่านระบบ e-Payment ธนาคารกรุงไทยเรียบร้อย',
  },
  {
    id: 'gov-4',
    agency: 'revenue_dept',
    agency_name: 'กรมสรรพากร (สำนักงานสรรพากรพื้นที่อยุธยา)',
    title: 'ยื่นแบบแสดงรายการภาษีเงินได้หัก ณ ที่จ่าย ภ.ง.ด.3 และ ภ.ง.ด.53 ประจำเดือน',
    filing_year: '2569 (สิงหาคม)',
    status: 'submitted',
    due_date: '2026-08-15',
    filing_date: '2026-08-11',
    reference_number: 'RD-PND353-256908-984',
    handled_by: 'ฝ่ายบัญชีการเงินนิติบุคคล',
    notes: 'ยื่นแบบ e-Filing กรมสรรพากรและชำระภาษีหัก ณ ที่จ่ายจ้างบริการแล้ว',
  },
  {
    id: 'gov-5',
    agency: 'local_municipality',
    agency_name: 'เทศบาลเมืองอโยธยา / องค์การบริหารส่วนตำบล',
    title: 'การประสานงานรอบการจัดเก็บขยะมูลฝอยและขออนุญาตตัดแต่งต้นไม้ใหญ่ริมทางสาธารณะ',
    filing_year: '2569',
    status: 'in_progress',
    due_date: '2026-08-30',
    reference_number: 'AYO-SAN-2569-182',
    handled_by: 'คุณศศิธร สุขสมบูรณ์',
    notes: 'ขอเพิ่มรอบเก็บขยะเป็นสัปดาห์ละ 3 วัน (จันทร์, พุธ, เสาร์) อยู่ระหว่างออกคำสั่งเทศกิจ',
  },
];

// 13. Initial Concierge Extra Services
export const INITIAL_CONCIERGE_SERVICES: ConciergeService[] = [
  {
    id: 'srv-1',
    name: 'บริการล้างแอร์ติดผนัง & ตรวจเช็คน้ำยาแอร์',
    category: 'aircon',
    provider_name: 'อยุธยา คูล แอร์เซอร์วิส (พาร์ทเนอร์นิติ)',
    rating: 4.9,
    phone: '081-445-5678',
    starting_price: 490,
    unit_desc: 'บาท / เครื่อง (รวมตรวจเช็คน้ำยาแอร์ฟรี)',
    description: 'ล้างทำความสะอาดด้วยปั๊มน้ำแรงดันสูง ถอดล้างโบว์เวอร์พัดลม เคลือบน้ำยาฆ่าเชื้อแบคทีเรีย พร้อมรับประกันงานล้าง 30 วัน',
    badges: ['ช่างผ่านการตรวจประวัติ', 'รับประกัน 30 วัน', 'ลด 10% สมาชิกลูกบ้าน'],
    is_verified: true,
  },
  {
    id: 'srv-2',
    name: 'บริการแม่บ้านทำความสะอาด Deep Clean & รายวัน',
    category: 'cleaning',
    provider_name: 'BeNeat Ayutthaya Concierge',
    rating: 4.8,
    phone: '089-778-9900',
    starting_price: 650,
    unit_desc: 'บาท / 3 ชั่วโมง (นำอุปกรณ์และน้ำยามาเอง)',
    description: 'แม่บ้านมืออาชีพ ผ่านการอบรมมาตรฐานโรงแรม 5 ดาว ทำความสะอาด ปัด กวาด เช็ด ถู ขัดห้องน้ำ เปลี่ยนผ้าปูที่นอน',
    badges: ['มีประกันสิ่งของเสียหาย', 'คัดกรองประวัติอาชญากรรม', 'จองล่วงหน้า 1 วัน'],
    is_verified: true,
  },
  {
    id: 'srv-3',
    name: 'บริการตัดหญ้า ตัดแต่งกิ่งไม้ และดูแลสวนในบ้าน',
    category: 'gardening',
    provider_name: 'กรีนการ์เด้น อยุธยาแลนด์สเคป',
    rating: 4.9,
    phone: '086-332-1122',
    starting_price: 800,
    unit_desc: 'บาท / ครั้ง (รวมขนกิ่งไม้ไปทิ้ง)',
    description: 'บริการตัดหญ้าด้วยเครื่องยนต์ ตัดแต่งพุ่มไม้ ทรงกลม/ทรงรั้ว ใส่ปุ๋ยบำรุงต้นไม้ และทำความสะอาดเก็บเศษหญ้าใส่ถุงขนทิ้ง',
    badges: ['รวมขนทิ้ง', 'เครื่องมือครบชุด', 'ประเมินราคาตามแปลง'],
    is_verified: true,
  },
  {
    id: 'srv-4',
    name: 'บริการอัดน้ำยากำจัดปลวกและแมลงรบกวนรอบตัวบ้าน',
    category: 'pest_control',
    provider_name: 'คิงส์ เพสท์ คอนโทรล (อยุธยา)',
    rating: 4.9,
    phone: '035-224-889',
    starting_price: 1500,
    unit_desc: 'บาท / รอบ (ฉีดเข้าท่อ Pipe Treatment)',
    description: 'ใช้น้ำยาเคมีเกรดพรีเมียม ไร้กลิ่นฉุน ปลอดภัยต่อคนและสัตว์เลี้ยง รับประกันผลงานการป้องกันปลวก 1 ปีเต็ม',
    badges: ['เคมีมาตรฐาน อย.', 'รับประกัน 1 ปี', 'ตรวจเช็คฟรีทุก 3 เดือน'],
    is_verified: true,
  },
  {
    id: 'srv-5',
    name: 'บริการช่างไฟฟ้า-ประปา ซ่อมบำรุงด่วนภายในบ้าน',
    category: 'handyman',
    provider_name: 'ทีมช่างวิชาชีพ สมาคมช่างอยุธยา',
    rating: 4.7,
    phone: '090-998-7711',
    starting_price: 350,
    unit_desc: 'บาท / จุด (ไม่รวมอะไหล่)',
    description: 'ซ่อมก๊อกน้ำรั่วซึม, ติดตั้งปั๊มน้ำ, เปลี่ยนเบรกเกอร์, เพิ่มปลั๊กไฟ, ติดตั้งเครื่องทำน้ำอุ่น, ซ่อมชักโครก',
    badges: ['ช่างมีใบอนุญาต กรมพัฒนาฝีมือแรงงาน', 'ราคามาตรฐาน'],
    is_verified: true,
  },
];

// 14. Initial Downloadable Documents
export const INITIAL_DOWNLOAD_DOCUMENTS: DownloadDocument[] = [
  {
    id: 'doc-1',
    code: 'FORM-RENOV-01',
    title: 'แบบฟอร์มขออนุญาตต่อเติม/ดัดแปลงอาคารและตกแต่งภายใน (Renovation Permit Form)',
    category: 'renovation',
    file_size: '1.2 MB',
    format: 'PDF',
    updated_at: '2026-06-01',
    download_count: 142,
    description: 'เอกสารยื่นขออนุญาตต่อเติมโรงรถ, ห้องครัว, ระแนงบังตา พร้อมรายละเอียดเงินมัดจำการก่อสร้างและกฎระเบียบเวลาทำงานช่าง',
  },
  {
    id: 'doc-2',
    code: 'FORM-DEBTFREE-02',
    title: 'แบบคำขอหนังสือรับรองปลอดหนี้ค่าส่วนกลางเพื่อการโอนกรรมสิทธิ์ (Debt-Free Certificate)',
    category: 'debt_free',
    file_size: '850 KB',
    format: 'PDF',
    updated_at: '2026-05-15',
    download_count: 89,
    description: 'แบบฟอร์มขอนิติบุคคลออกหนังสือรับรองปลอดหนี้ สำหรับใช้ประกอบการจดทะเบียนโอนกรรมสิทธิ์ ณ สำนักงานที่ดิน',
  },
  {
    id: 'doc-3',
    code: 'FORM-PROXY-03',
    title: 'หนังสือมอบฉันทะเข้าร่วมประชุมใหญ่สามัญเจ้าของร่วม (AGM Proxy Form)',
    category: 'agm_proxy',
    file_size: '620 KB',
    format: 'PDF',
    updated_at: '2026-07-20',
    download_count: 215,
    description: 'แบบฟอร์มหนังสือมอบฉันทะให้บุคคลอื่นเข้าร่วมประชุมและออกเสียงลงมติแทนในการประชุมใหญ่สามัญประจำปี',
  },
  {
    id: 'doc-4',
    code: 'RULE-BYLAWS-04',
    title: 'ข้อบังคับนิติบุคคลหมู่บ้านจัดสรร นราวดี อิลิแกนซ์ ฉบับสมบูรณ์ (Juristic By-laws & Regulations)',
    category: 'bylaws',
    file_size: '3.8 MB',
    format: 'PDF',
    updated_at: '2025-10-20',
    download_count: 530,
    description: 'ข้อบังคับทางกฎหมายว่าด้วยการอยู่อาศัยร่วมกัน, การใช้ทรัพย์ส่วนกลาง, การคิดคำนวณค่าส่วนกลาง และบทลงโทษผู้กระทำผิด',
  },
  {
    id: 'doc-5',
    code: 'FORM-KEYCARD-05',
    title: 'แบบคำขอสติ๊กเกอร์เข้า-ออกโครงการและลงทะเบียนบัตร RFID Keycard เพิ่มเติม',
    category: 'keycard',
    file_size: '540 KB',
    format: 'PDF',
    updated_at: '2026-04-10',
    download_count: 178,
    description: 'แบบฟอร์มลงทะเบียนยานพาหนะของลูกบ้าน ขอสติ๊กเกอร์ติดหน้ารถ และบัตรผ่านไม้กั้นอัตโนมัติ',
  },
  {
    id: 'doc-6',
    code: 'REPORT-FIN-2568',
    title: 'รายงานงบการเงินประจำปี 2568 ที่ผ่านการตรวจสอบโดยผู้สอบบัญชีรับอนุญาต (Audited Financial Statement)',
    category: 'financial',
    file_size: '4.5 MB',
    format: 'PDF',
    updated_at: '2026-04-20',
    download_count: 310,
    description: 'รายงานงบดุล งบรายรับ-รายจ่าย รายการเงินกองทุนสำรอง และรายงานของผู้สอบบัญชีรับอนุญาต (CPA)',
  },
];
